export const filterValues = [
    {
      "name": "None",
      "class": "#no-filter",
      "filter:": "",
      filtersInObj : {},
    },
    {
      "name": "1977",
      "class": "filter-1977",
      "filter": "sepia(.5) hue-rotate(-30deg) saturate(1.4)",
      filtersInObj : {
        sepia : 50, hueRotate : -30, saturate : 140
      }
    },
    {
      "name": "Aden",
      "class": "filter-aden",
      "filter": "sepia(.2) brightness(1.15) saturate(1.4)",
      filtersInObj : {
        sepia : 20, brightness : 115, saturate : 140
      }
    },
    {
      "name": "Amaro",
      "class": "filter-amaro",
      "filter": "sepia(.35) contrast(1.1) brightness(1.2) saturate(1.3)",
      filtersInObj : {
        sepia : 35, contrast : 110, brightness : 120, saturate : 130
      }
    },
    {
      "name": "Ashby",
      "class": "filter-ashby",
      "filter": "sepia(.5) contrast(1.2) saturate(1.8)",
      filtersInObj : {
        sepia : 50, contrast : 120, saturate : 180
      }
    },
    {
      "name": "Brannan",
      "class": "filter-brannan",
      "filter": "sepia(.4) contrast(1.25) brightness(1.1) saturate(.9) hue-rotate(-2deg)",
      filtersInObj : {
        sepia : 40, contrast : 125, brightness : 110, saturate : 90, hueRotate : -2,
      }
    },
    {
      "name": "Brooklyn",
      "class": "filter-brooklyn",
      "filter": "sepia(.25) contrast(1.25) brightness(1.25) hue-rotate(5deg)",
      filtersInObj : {
        sepia : 25, contrast : 125, brightness : 125, hueRotate : 5,
      }
    },
    {
      "name": "Charmes",
      "class": "filter-charmes",
      "filter": "sepia(.25) contrast(1.25) brightness(1.25) saturate(1.35) hue-rotate(-5deg)",
      filtersInObj : {
        sepia : 25, contrast : 125, brightness : 125, saturate : 135, hueRotate : -5,
      }
    },
    {
      "name": "Clarendon",
      "class": "filter-clarendon",
      "filter": "sepia(.15) contrast(1.25) brightness(1.25) hue-rotate(5deg)",
      filtersInObj : {
        sepia : 15, contrast : 125, brightness : 125, hueRotate : 5,
      }
    },
    {
      "name": "Crema",
      "class": "filter-crema",
      "filter": "sepia(.5) contrast(1.25) brightness(1.15) saturate(.9) hue-rotate(-2deg)",
      filtersInObj : {
        sepia : 50, contrast : 125, brightness : 115, saturate : 90, hueRotate : -2,
      }
    },
    {
      "name": "Dogpatch",
      "class": "filter-dogpatch",
      "filter": "sepia(.35) saturate(1.1) contrast(1.5)",
      filtersInObj : {
        sepia : 35, saturate : 110, contrast : 150,
      }
    },
    {
      "name": "Earlybird",
      "class": "filter-earlybird",
      "filter": "sepia(.25) contrast(1.25) brightness(1.15) saturate(.9) hue-rotate(-5deg)",
      filtersInObj : {
        sepia : 25, contrast : 125, brightness : 115, saturate : 90, hueRotate: -5,
      }
    },
    {
      "name": "Gingham",
      "class": "filter-gingham",
      "filter": "contrast(1.1) brightness(1.1)",
      filtersInObj : {
        contrast : 110, brightness : 110,
      }
    },
    {
      "name": "Ginza",
      "class": "filter-ginza",
      "filter": "sepia(.25) contrast(1.15) brightness(1.2) saturate(1.35) hue-rotate(-5deg)",
      filtersInObj : {
        sepia : 25, contrast : 115, brightness : 120, saturate : 135, hueRotate: -5,
      }
    },
    {
      "name": "Hefe",
      "class": "filter-hefe",
      "filter": "sepia(.4) contrast(1.5) brightness(1.2) saturate(1.4) hue-rotate(-10deg)",
      filtersInObj : {
        sepia : 40, contrast : 150, brightness : 120, saturate : 140, hueRotate: -10,
      }
    },
    {
      "name": "Helena",
      "class": "filter-helena",
      "filter": "sepia(.5) contrast(1.05) brightness(1.05) saturate(1.35)",
      filtersInObj : {
        sepia : 50, contrast : 105, brightness : 105, saturate : 135,
      }
    },
    {
      "name": "Hudson",
      "class": "filter-hudson",
      "filter": "sepia(.25) contrast(1.2) brightness(1.2) saturate(1.05) hue-rotate(-15deg)",
      filtersInObj : {
        sepia : 25, contrast : 120, brightness : 120, saturate : 105, hueRotate: -15,
      }
    },
    {
      "name": "Inkwell",
      "class": "filter-inkwell",
      "filter": "brightness(1.25) contrast(.85) grayscale(1)",
      filtersInObj : {
        brightness : 125, contrast : 85, grayScale : 100,
      }
    },
    {
      "name": "juno",
      "class": "filter-juno",
      "filter": "sepia(.35) contrast(1.15) brightness(1.15) saturate(1.8)",
      filtersInObj : {
        sepia : 35, contrast : 115, brightness : 115, saturate : 180,
      }
    },
    {
      "name": "Kelvin",
      "class": "filter-kelvin",
      "filter": "sepia(.15) contrast(1.5) brightness(1.1) hue-rotate(-10deg)",
      filtersInObj : {
        sepia : 15, contrast : 150, brightness : 110, hueRotate: -10,
      }
    },
    {
      "name": "Lark",
      "class": "filter-lark",
      "filter": "sepia(.25) contrast(1.2) brightness(1.3) saturate(1.25)",
      filtersInObj : {
        sepia : 25, contrast : 120, brightness : 130, saturate : 125,
      }
    },
    {
      "name": "Lo-Fi",
      "class": "filter-lofi",
      "filter": "saturate(1.1) contrast(1.5)",
      filtersInObj : {
        saturate : 120, contrast : 150,
      }
    },
    {
      "name": "Ludwig",
      "class": "filter-ludwig",
      "filter": "sepia(.25) contrast(1.05) brightness(1.05) saturate(2)",
      filtersInObj : {
        sepia : 25, contrast : 105, brightness : 105, saturate : 200,
      }
    },
    {
      "name": "Maven",
      "class": "filter-maven",
      "filter": "sepia(.35) contrast(1.05) brightness(1.05) saturate(1.75)",
      filtersInObj : {
        sepia : 35, contrast : 105, brightness : 105, saturate : 175,
      }
    },
    {
      "name": "Mayfair",
      "class": "filter-mayfair",
      "filter": "contrast(1.1) brightness(1.15) saturate(1.1)",
      filtersInObj : {
        contrast : 110, brightness : 115, saturate : 110,
      }
    },
    {
      "name": "Moon",
      "class": "filter-moon",
      "filter": "brightness(1.4) contrast(.95) saturate(0) sepia(.35)",
      filtersInObj : {
        sepia: 35, brightness : 140, contrast : 95, saturate : 0,
      }
    },
    {
      "name": "Nashville",
      "class": "filter-nashville",
      "filter": "sepia(.25) contrast(1.5) brightness(.9) hue-rotate(-15deg)",
      filtersInObj : {
        sepia : 25, contrast : 150, brightness : 90, hueRotate : -15,
      }
    },
    {
      "name": "Perpetua",
      "class": "filter-perpetua",
      "filter": "contrast(1.1) brightness(1.25) saturate(1.1)",
      filtersInObj : {
        contrast : 110, brightness : 125, saturate : 110,
      }
    },
    {
      "name": "Poprocket",
      "class": "filter-poprocket",
      "filter": "sepia(.15) brightness(1.2)",
      filtersInObj : {
        sepia : 15, brightness : 120,
      }
    },
    {
      "name": "Reyes",
      "class": "filter-reyes",
      "filter": "sepia(.75) contrast(.75) brightness(1.25) saturate(1.4)",
      filtersInObj : {
        sepia : 75, contrast : 75, brightness : 125, saturate : 140,
      }
    },
    {
      "name": "Rise",
      "class": "filter-rise",
      "filter": "sepia(.25) contrast(1.25) brightness(1.2) saturate(.9)",
      filtersInObj : {
        sepia : 25, contrast : 125, brightness : 120, saturate : 90,
      }
    },
    {
      "name": "Sierra",
      "class": "filter-sierra",
      "filter": "sepia(.25) contrast(1.5) brightness(.9) hue-rotate(-15deg)",
      filtersInObj : {
        sepia : 25, contrast : 150, brightness : 90, hueRotate : -15,
      }
    },
    {
      "name": "Skyline",
      "class": "filter-skyline",
      "filter": "sepia(.15) contrast(1.25) brightness(1.25) saturate(1.2)",
      filtersInObj : {
        sepia : 15, contrast : 125, brightness : 125, saturate : 120,
      }
    },
    {
      "name": "Slumber",
      "class": "filter-slumber",
      "filter": "sepia(.35) contrast(1.25) saturate(1.25)",
      filtersInObj : {
        sepia : 35, contrast : 125, saturate : 125,
      }
    },
    {
      "name": "Stinson",
      "class": "filter-stinson",
      "filter": "sepia(.35) contrast(1.25) brightness(1.1) saturate(1.25)",
      filtersInObj : {
        sepia : 35, contrast : 125, brightness : 110, saturate : 125,
      }
    },
    {
      "name": "Sutro",
      "class": "filter-sutro",
      "filter": "sepia(.4) contrast(1.2) brightness(.9) saturate(1.4) hue-rotate(-10deg)",
      filtersInObj : {
        sepia : 40, contrast : 120, brightness : 90, saturate : 140, hueRotate : -10,
      }
    },
    {
      "name": "Toaster",
      "class": "filter-toaster",
      "filter": "sepia(.25) contrast(1.5) brightness(.95) hue-rotate(-15deg)",
      filtersInObj : {
        sepia : 25, contrast : 150, brightness : 95, hueRotate : -15,
      }
    },
    {
      "name": "Valencia",
      "class": "filter-valencia",
      "filter": "sepia(.25) contrast(1.1) brightness(1.1)",
      filtersInObj : {
        sepia : 25, contrast : 110, brightness : 110,
      }
    },
    {
      "name": "Vesper",
      "class": "filter-vesper",
      "filter": "sepia(.35) contrast(1.15) brightness(1.2) saturate(1.3)",
      filtersInObj : {
        sepia : 35, contrast : 115, brightness : 120, saturate : 130,
      }
    },
    {
      "name": "Walden",
      "class": "filter-walden",
      "filter": "sepia(.35) contrast(.8) brightness(1.25) saturate(1.4)",
      filtersInObj : {
        sepia : 35, contrast : 80, brightness : 125, saturate : 140,
      }
    },
    {
      "name": "Willow",
      "class": "filter-willow",
      "filter": "brightness(1.2) contrast(.85) saturate(.05) sepia(.2)",
      filtersInObj : {
        sepia : 20, contrast : 85, brightness : 120, saturate : 5,
      }
    },
    {
      "name": "X-Pro II",
      "class": "filter-xpro-ii",
      "filter": "sepia(.45) contrast(1.25) brightness(1.75) saturate(1.3) hue-rotate(-5deg)",
      filtersInObj : {
        sepia : 45, contrast : 125, brightness : 175, saturate : 130, hueRotate : -5,
      }
    }
  ]